$(function() {
  var updateInputState = function() {
    var $this = $(this);
    if ($this.val()) {
      $this.addClass('used');
    } else {
      $this.removeClass('used');
    }
  };

  var $loginInputs = $('input').not(':hidden');

  $loginInputs.each(updateInputState);
  setTimeout(function() {
    $loginInputs.each(updateInputState);
  }, 100);

  $loginInputs.on('blur input change', updateInputState);

  var $ripples = $('.ripples');

  $ripples.on('click.Ripples', function(e) {

    var $this = $(this);
    var $offset = $this.parent().offset();
    var $circle = $this.find('.ripplesCircle');

    var x = e.pageX - $offset.left;
    var y = e.pageY - $offset.top;

    $circle.css({
      top: y + 'px',
      left: x + 'px',
    });

    $this.addClass('is-active');

  });

  $ripples.on('animationend webkitAnimationEnd mozAnimationEnd oanimationend MSAnimationEnd', function() {
    $(this).removeClass('is-active');
  });

});
